module.exports = __webpack_public_path__ + "static/img/3.2dbcf10b.jpg";